export default "__VITE_ASSET__3nakBIc___"